/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PatientFirstName/view.blocks to change it.
import Input from 'DesignSystem/Input/index'
import PreviousQuestion from './PreviousQuestion/index'
import Question from 'DesignSystem/Question/index'
import React from 'react'
import Status from './Status/index'
import styles from './view.module.css'
import useIsBefore from 'Simple/hooks/useIsBefore'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function PatientFirstName({
  children,
  viewPath = "/App/Form/Data/ProvideData/PatientFirstName",
  onChange,
  onSubmit,
  value
  
}) {
  let isBefore = useIsBefore()
  return (<React.Fragment
>
<div
  data-testid="PatientFirstName.Vertical"
  data-view-path={viewPath}
 style={{'--o-1-ZqHiHU': isBefore ? 0 : 1}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="PatientFirstName.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<PreviousQuestion
  viewPath={`${viewPath}/PreviousQuestion`}
/>
<Question
  viewPath={`${viewPath}/Question`}
 marginBottom={0}
 marginTop={4}
 text="What is the patient's first name?"
/>
</div>
<Input
  viewPath={`${viewPath}/Input`}
 autoFocus={true}
 onChange={onChange}
 onSubmit={onSubmit}
 placeholder="start typing..."
 type="text"
 value={value}
/>
<Status
  viewPath={`${viewPath}/Status`}
 onSubmit={onSubmit}
/>
</div>
{children}
</React.Fragment>)
}